import React from "react";
import styled, { css } from "styled-components";
import { MANAGE_ARREARS_ROUTE } from "./../IncreaseRepayments/route.constants";
import { ManageRepaymentsOption } from "../../manageRepaymentsOption";
import { useAccount } from "../../../../hooks/client";
import { DoubleRepayments } from "../IncreaseRepayments/components/doubleRepayments";
import { MakeExtraRepayments } from "../IncreaseRepayments/components/MakeExtraRepayments/makeExtraRepayments";
import { PayOverThreeRepayments } from "./payOverThreeRepayments";
import { PayFullArrears } from "./payFullArrears";
import { MANAGE_MY_ARREARS_STATES } from "../../../../constants/commonConstants";

const Wrapper = styled.div(({ theme }) => css`
  .manage-arrears-title,
  .decrease-title {
    text-transform: ${theme.fonts.headingCase};
    font-size: 18px;
    color: ${theme.palette.status.bad};
    font-weight: ${theme.fonts.headingWeight};
  }

  .decrease-title {
    padding-top: 35px;
  }

  li {
    padding: 5px 0;
  }

  .decrease-info {
    padding: 15px 0 15px;
  }

  .chat-manage-repayments {
    color: ${theme.palette.status.goodAlt};
  }
`);

export const ManageArrearsOptions = ({ accountId }) => {
  const { arrears } = useAccount(accountId) || {};
  let showPayOverThreeForm = true;

  if (
    arrears === MANAGE_MY_ARREARS_STATES.ARREARS_LESS_THAN_THREE ||
    arrears === MANAGE_MY_ARREARS_STATES.ARREARS_LOC
  ) {
    showPayOverThreeForm = false;
  }

  return (
    <Wrapper>
      <div className="manage-arrears-title">Manage my arrears</div>
      <ul>
        <li>
          <ManageRepaymentsOption
            accountId={accountId}
            title="Pay full arrears now"
            subRoute={MANAGE_ARREARS_ROUTE.PAY_FULL}
            changeTitleColourWhenActive={true}
          >
            <PayFullArrears accountId={accountId} />
          </ManageRepaymentsOption>
        </li>
        {showPayOverThreeForm && (
          <li>
            <ManageRepaymentsOption
              accountId={accountId}
              title="Pay full arrears over the next 3 repayments"
              subRoute={MANAGE_ARREARS_ROUTE.PAY_FULL_THREE_REPAYMENTS}
              changeTitleColourWhenActive={true}
            >
              <PayOverThreeRepayments accountId={accountId} />
            </ManageRepaymentsOption>
          </li>
        )}
        <li>
          <ManageRepaymentsOption
            accountId={accountId}
            title="Make an extra repayment"
            subRoute={MANAGE_ARREARS_ROUTE.PAY_EXTRA}
            changeTitleColourWhenActive={true}
          >
            <MakeExtraRepayments accountId={accountId} />
          </ManageRepaymentsOption>
        </li>
        <li>
          <ManageRepaymentsOption
            accountId={accountId}
            title="Double the next repayment"
            subRoute={MANAGE_ARREARS_ROUTE.PAY_DOUBLE}
            changeTitleColourWhenActive={true}
          >
            <DoubleRepayments accountId={accountId} />
          </ManageRepaymentsOption>
        </li>
      </ul>
    </Wrapper>
  );
};
